import { render, staticRenderFns } from "./PurchasesPaymentViewLogs.vue?vue&type=template&id=0fc89901&"
import script from "./PurchasesPaymentViewLogs.vue?vue&type=script&lang=js&"
export * from "./PurchasesPaymentViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports